// Backend sends more data, but the frontend only uses these
export interface AddDependentRequest {
  kinship_degree: KinshipDegree;
  name: string;
  email: string;
}

export interface UpdateDependentRequest {
  kinship_degree: KinshipDegree;
  name: string;
  email: string;
  id: number;
}

export interface Dependent {
  id: number;
  kinship_degree: KinshipDegree;
  user: {
    id: number;
    nome: string;
    email: string;
    ultimo_acesso: string;
  };
}

export interface DependentsResponse {
  data: Dependent[];
  statusCode: number;
}

export enum KinshipDegree {
  Parent = 'parent',
  Spouse = 'spouse',
  Child = 'child',
  Brother = 'brother',
  Other = 'other',
}

export const kinshipDegreeLabels = {
  [KinshipDegree.Child]: 'Filho ou Filha',
  [KinshipDegree.Spouse]: 'Marido ou Esposa',
  [KinshipDegree.Parent]: 'Pai ou Mãe',
  [KinshipDegree.Brother]: 'Irmão ou Irmã',
  [KinshipDegree.Other]: 'Outro',
};
